import { BACKEND_URL as __BACKEND_URL__ } from "../lib/backend-url";
export const STORE_LOCATIONS = [
  { id: "cangaiba", name: "Vencidinho Cangaíba", address: "Av. Cangaíba, 2100", cnpj: "33398343000105" },
  { id: "sjc", name: "Best By SJC", address: "Av. Iguape, 460 - Jardim Satélite, São José dos Campos - SP, 12230-720", cnpj: "52968282000208" },
  { id: "jacarei", name: "Best By Jacareí", address: "Rodovia Geraldo Scavone 1155, Jacareí 12305490", cnpj: "52968282000119" },
  { id: "panamby", name: "Best By Panamby", address: "São Paulo - SP", cnpj: "" }
];

export const STORES = [
  { id: "vencidinho_cangaiba", name: "Vencidinho - Cangaíba" },
  { id: "bestby_sjc", name: "Best By - SJC" },
  { id: "bestby_jacarei", name: "Best By - Jacareí" },
  { id: "bestby_panamby", name: "Best By - Panamby" }
];

export const MARKET_TYPES = [
  { id: "supermarket", label: "Supermercado", icon: "store" },
  { id: "hypermarket", label: "Hipermercado", icon: "store" },
  { id: "wholesale", label: "Atacado", icon: "truck" },
  { id: "convenience", label: "Conveniência", icon: "shopping-cart" },
  { id: "pharmacy", label: "Farmácia", icon: "building" },
  { id: "distributor", label: "Distribuidor", icon: "package" }
];

export const BACKEND_URL = __BACKEND_URL__;
export const API = `${BACKEND_URL}/api`;
